import { makeStyles, Theme } from "@material-ui/core/styles";
import { lightGrey } from "../../../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginTop: theme.spacing(4),
  },
  title: {
    color: "#929FAD",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  containerList: {
    overflow: "auto",
    width: "calc(100vw - 432px)",
  },
  beneficiarieContainer: {
    minWidth: "48%",
    height: "241px",
    backgroundColor: lightGrey,
    marginRight: "26px",
    borderRadius: "4px",
    padding: theme.spacing(3),
  },
  nameLabel: {
    fontWeight: 700,
    lineHeight: "21px",
  },
  label: {
    lineHeight: "18px",
  },
  dataStyle: {
    marginLeft: "auto",
  },
  dataBoldStyle: {
    marginLeft: "auto",
    fontWeight: 700,
  },
  row: {
    marginBottom: theme.spacing(2),
  },
  lineSeparator: {
    width: "100%",
    height: "1px",
    backgroundColor: "#CFDAE5",
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
